import { get } from "radash"

import type { GeocodeV4Response } from "@be-miniapp/api"
import type { GeocodeV4Address } from "@be-miniapp/types"

const normalizeAddressForKeyword = (address: string) => {
  const addressSplitted = address.split(",")
  const name =
    addressSplitted.length >= 2
      ? `${addressSplitted[0]}, ${addressSplitted[1]}`
      : addressSplitted[0]

  return name
}

export const fromStandardLocationToGeocodeLocation = (
  locationData: any
): GeocodeV4Response => {
  return {
    address: "",
    status: "",
    dev_message: "",
    cache: false,
    source: locationData.source,
    code: 0,
    in_polygon: false,
    address_full: {
      results: [
        {
          geometry: {
            location: {
              lat: locationData.result.geometry.location.lat,
              lng: locationData.result.geometry.location.lng,
            },
            location_type: locationData.result.geometry.location_type,
          },
          formatted_address: locationData.result.formatted_address,
          place_id: locationData.result.place_id,
          address_components: locationData.result.address_components,
          types: locationData.result.types,
          type: locationData.result.type,
          children: [],
        },
      ],
      children: [],
      status: locationData.status,
    },
    polygon: {
      description: "",
      structured_formatting: {
        main_text: "",
        secondary_text: "",
      },
      coordinates: [],
    },
  }
}

const fromGeocodeLocationToStandardLocation = (
  geocodeLocation: GeocodeV4Response
) => {
  const firstLocation = get(
    geocodeLocation,
    "address_full.results[0]"
  ) as GeocodeV4Address

  const name =
    (firstLocation?.formatted_address
      ? firstLocation.formatted_address.split(",")[0]
      : undefined) ??
    get(
      geocodeLocation,
      "polygon.structured_formatting.main_text",
      get(
        geocodeLocation,
        "address_components[0].long_name",
        firstLocation?.formatted_address.split(",")[0]
      )
    )
  const address =
    firstLocation?.formatted_address ??
    get(
      geocodeLocation,
      "polygon.structured_formatting.secondary_text",
      get(
        geocodeLocation,
        "formatted_address",
        firstLocation?.formatted_address
      )
    )

  return {
    name: name as string,
    address: address as string,
    placeId: get(
      geocodeLocation,
      "place_id",
      firstLocation?.place_id
    ) as string,
    location: {
      latitude: Number(
        get(
          geocodeLocation,
          "geometry.location.lat",
          firstLocation?.geometry.location.lat ?? 0
        )
      ),
      longitude: Number(
        get(
          geocodeLocation,
          "geometry.location.lng",
          firstLocation?.geometry.location.lng ?? 0
        )
      ),
    },
  }
}

export { normalizeAddressForKeyword, fromGeocodeLocationToStandardLocation }
